import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import ReduxToastr from 'react-redux-toastr';
import { ConnectedRouter } from 'react-router-redux';
import './index.scss';
import './toastr.scss';
import { Provider } from 'react-redux';
import configureStore from './store';
import * as api from './api';
import { Route } from 'react-router-dom';
import { requireEtoAuthentication, AuthTokenObserver } from './auth';
import { AccessibilityNotificationComponent, accessibilityNotificationsEmitter, TitleAnnouncer } from './common';
import { history } from './history';

const store = configureStore({});

api.config.store = store;
accessibilityNotificationsEmitter.store = store;
store.subscribe(AuthTokenObserver(store));

ReactDOM.render(
  <Provider store={store}>
    <div>
      <TitleAnnouncer/>
      <ConnectedRouter history={history}>
        <Route path="/" component={requireEtoAuthentication(App)} />
      </ConnectedRouter>
      <div aria-live="polite">
        <ReduxToastr
          timeOut={6000}
          newestOnTop={false}
          preventDuplicates={true}
          position="top-right"
          transitionIn="fadeIn"
          transitionOut="fadeOut"
          progressBar />
      </div>
      <AccessibilityNotificationComponent/>
    </div>
  </Provider>,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// src/index.js